module.exports = __webpack_public_path__ + "img/1.47b1ffa0.png";